export const onEdit = token => ({
  widget: 'tokens',
  type: 'onEdit',
  payload: { token },
})



// WEBPACK FOOTER //
// ./src/tokens/actions/onEdit.js